import angular from 'angular';
import './resource';

const module = angular.module('whyline.resources.identification', [
]);

const IdentificationFactory = (API_URL, $http) => {
	const Identification = {};

	Identification.Identify = (idNumber, gender, organizationId, calledFrom) => {
		const queryParams = {
			idNumber,
			gender,
			organizationId,
			calledFrom,
		};
		const queryString = Object.keys(queryParams).map((key) => `${key}=${queryParams[key]}`).join('&');
		const url = `${API_URL}identification/identify?${queryString}`;
		return $http.get(url).then(response => response.data);
	}

	return Identification;
};

module.export = module.factory('Identification', IdentificationFactory);
